export enum AtomAnchorTypeEnum {
  PRIMARY = "primary",
  OUTLINE_PRIMARY = "outline-primary",
  SECONDARY = "secondary",
  DANGER = "danger",
  DISABLED = "disabled",
}
